import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { LsbApi, RequestStrategyEnum, type GetInquiryRequest, type GetInquiryResponse, type WithSignal } from '@shared/api';

const getInquiryEffect = createEffect(({ signal, ...request }: WithSignal<GetInquiryRequest>) => LsbApi.getInquiry(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<GetInquiryResponse | null>(null)
  .on(getInquiryEffect.done, (_, data) => data.result.data || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(true)
  .on(getInquiryEffect.pending, (_, data) => data)
  .on(getInquiryEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getInquiryEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getInquiryEffect, () => null)
  .on(getInquiryEffect.fail, () => 'Something went wrong while fetching Inquiry. Please try again.')
  .on(getInquiryEffect.done, () => null)
  .reset(clearEvent);

const getInquiryApi = ApiUtils.wrapperApi(getInquiryEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getInquiryApi.cancel());

export const $inquiryStore = {
  events: {
    getInquiry: getInquiryApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
